import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { UserMgmtService } from '../user-management.service';

@Component({
  selector: 'app-chat-support',
  templateUrl: './chat-support.component.html',
  styleUrls: ['./chat-support.component.scss']
})
export class ChatSupportComponent implements OnInit {
  
  @ViewChild('scrollMe',null) private myScrollContainer: ElementRef;
chatDetail:any;
userId:"";
private modalRef: NgbModalRef;
modelOptions: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false
};
closeResult: string;
// chatList=[
//   {
//   name:"Hariom Khurana",
//   isLeft :true,
//   Message:"hello how r u",
//   sentAt: 1659782979
// },
// {
//   name:"Hariom Khurana",
//   isLeft :true,
//   Message:"why you are not replying",
//   sentAt: 1659782979
// },  {
//   name:"Admin",
//   isLeft :false,
//   Message:"I am Fine",
//   sentAt: 1659782979
// },
// {
//   name:"Hariom Khurana",
//   isLeft :true,
//   Message:"hello how r u",
//   sentAt: 1659782979
// },
// {
//   name:"Hariom Khurana",
//   isLeft :true,
//   Message:"why you are not replying",
//   sentAt: 1659782979
// },  {
//   name:"Admin",
//   isLeft :false,
//   Message:"I am Fine",
//   sentAt: 1659782979
// },
// {
//   name:"Hariom Khurana",
//   isLeft :true,
//   Message:"hello how r u",
//   sentAt: 1659782979
// },
// {
//   name:"Hariom Khurana",
//   isLeft :true,
//   Message:"why you are not replying",
//   sentAt: 1659782979
// },  {
//   name:"Admin",
//   isLeft :false,
//   Message:"I am Fine",
//   sentAt: 1659782979
// }
  
// ]
chatList =[];
textMessage:string =""
  constructor(private userMgmtService: UserMgmtService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private modalService: NgbModal,) { }

  ngOnInit() {
    this.userId = this.route.snapshot.params["userId"];
    this.getUserDetail();
    this.getChat();
  }

  getUserDetail() {
    this.spinner.show();
    let query ="userId="+this.userId;
    this.userMgmtService.SearchUserList(query).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.chatDetail =  res.data.userList[0];
       
        this.spinner.hide();
      } else {
        this.spinner.hide()
      }
    });
  }
  getChat() {
    this.spinner.show();
    let query ="userId="+this.userId;
    this.chatList = [];
    this.userMgmtService.getChatList(query).subscribe(res => {
      if ((res["message"] == "Success")) {
       res.data.chatList.forEach(element => {
         if(element['senderId'] == this.userId){
           element['isLeft'] = false;
           element['name'] = "" 
         }else {
          element['name'] = element['adminFullName'] +" Admin"
          element['isLeft'] = true;
         }
         this.chatList.push(element)
         
       });
        this.spinner.hide();
        setTimeout(() => {
          this.scrollToBottom();
        }, 10);
      } else {
        this.spinner.hide()
      }
    });
  }
  sendMessage() {
    this.spinner.show();
    let request = {
      message:this.textMessage,
      receiverId:this.userId

    }
    this.userMgmtService.sendMessageApi(request).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.textMessage = "";
          this.getChat();
      } else {
        this.spinner.hide()
      }
    });
  }
  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;

    } catch (err) { }
  }
  chatId="";
  deleteStatusModal(row, content, btn) {
    this.chatId = row.chatId;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  deleteRecord(record: any) {
    this.spinner.show();
    this.userMgmtService.deleteChat(this.chatId).subscribe(res => {
      if ((res["message"] == "Success")) { 
        Swal.fire("Success", "Message Deleted successfully!", "success");
        this.getChat();
        this.modalRef.close();
        this.spinner.hide();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

}
